<template>
	<div class="bg-page">
		<div class="background-card" v-if="divida">
			<div class="debit-card">
				<div class="img-box">
					<img v-if="divida.loj_caminho_logo && divida.loj_caminho_logo.length > 0" :src="divida.loj_caminho_logo" />
					<img v-else-if="parceiro && parceiroConfig.sessoes.logoForBackgroundWhite" :src="parceiro && parceiroConfig.sessoes.logoForBackgroundWhite.campos" />
					<img v-else-if="parceiro" :src="parceiroConfig.logo" />
					<img v-else src="../../../../assets/images/teae.png" />
				</div>
				<div class="container-info">
					<div class="info">
						<div>
							<div class="row-info">
								<p style="margin-bottom: 5px">{{ divida.loj_fantasia }}</p>
								<h6>{{ `CNPJ: ${cnpjMask(divida.loj_cpf_cnpj)}` }}</h6>
							</div>
						</div>
						<div class="row-totals">
							<div v-if="divida.possuiLancamentosFuturos" class="totals mr-10">
								<h6>Futuros</h6>
								<h2><span>R$</span> {{ money2(divida.vlrDebito) }}</h2>
							</div>
							<div class="totals">
								<h6>Valor atualizado</h6>
								<h2><span>R$</span> {{ money2(divida.saldo_contrato_com_desconto) }}</h2>
								<!--                                <h6>Valor à vista-->
								<!--                                    <span class="tag-porcent">-->
								<!--                                    - {{divida.total_desconto > 0 ? parseInt(divida.saldo_contrato_com_desconto/divida.saldo_contrato*100-100) : 0}}%-->
								<!--                                    </span>-->
								<!--                                </h6>-->
								<!--                                <h2><span>R$</span> {{money2(divida.saldo_contrato_com_desconto)}}</h2>-->
							</div>
							<div class="totals" v-if="parceiroConfig.sessoes.customization == undefined ? true : parceiroConfig.sessoes.customization.campos.myDebits.flgValorOriginal">
								<h6 style="color: #dadbdf">Valor original</h6>
								<h2 style="color: #dadbdf">
									<span style="color: #dadbdf">R$</span>
									{{ money2(divida.saldo_contrato) }}
								</h2>
							</div>
						</div>
					</div>
					<div class="box-buttons">
						<div style="width: 40%; padding-right: 10px">
							<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'" @click.native="showComponent = showComponent === 'DetailsDebit' ? null : 'DetailsDebit'" :secondaryColor="true" text="Detalhes" />
						</div>
						<div style="width: 80%; padding-left: 10px">
							<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'" @click.native="showPaymentsOptions()" text="Opções de parcelamento" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="divida.porcentagem_desconto_total && divida.porcentagem_desconto_total > 0 && !showComponent" class="card-promotion-debit">
			<p class="message-top" :style="{ backgroundColor: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }">
				<b>{{ divida.loj_razao_social }}</b> lhe proporciona um <b>SUPER DESCONTO</b> de
				<b>{{ divida.porcentagem_desconto_total }}%</b>
				para você quitar sua dívida e voltar a ter seu CPF positivado!
			</p>
			<div class="amount-boleto">
				<div style="display: flex; flex-direction: column; justify-content: center">
					<h5>
						São
						<b :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }"> R$ {{ money2(divida.total_desconto) }} </b>
						de desconto.
						<b :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }"> É IMPERDÍVEL! </b>
					</h5>
					<p>Vencimento do boleto em 22/03/2021</p>
				</div>

				<div class="values-boleto">
					<div class="totals">
						<h6>Valor à vista</h6>
						<h2 :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }">
							<span>R$</span>
							{{ money2(divida.saldo_contrato_com_desconto) }}
						</h2>
					</div>
					<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)'" @click.native="showPaymentsOptions()" text="Gerar boleto" />
				</div>
			</div>
		</div>
		<component v-if="showComponent" :formasPagamento="formasPagamento" :divida="divida" :is="showComponent" />
	</div>
</template>

<script>
import ButtonDefault from "@/components/buttons/ButtonDefault"
import DetailsDebit from "./DetailsDebit"
import globalMethods from "@/mixins/globalMethods"
import PaymentOptionsDebit from "./PaymentOptionsDebit"
import { mapActions, mapState, mapMutations } from "vuex"
export default {
	name: "DebitCard",
	components: { PaymentOptionsDebit, DetailsDebit, ButtonDefault },
	mixins: [globalMethods],
	props: ["divida"],
	data() {
		return {
			showComponent: 0,
			formasPagamento: {
				boleto: [],
				cartao: [],
				pix: [],
				link: []
			}
		}
	},
	mounted() {
		this.createParcelasFuturas()
	},
	computed: {
		...mapState({
			parceiro: state => state.parceiro,
			parceiroConfig: state => state.parceiroConfig
		})
	},
	methods: {
		...mapActions(["action_getValoresAcordo"]),
		...mapMutations(["SET_LOADING", "SET_LOADING_MESSAGE"]),
		async showPaymentsOptions() {
			if (this.showComponent === "PaymentOptionsDebit") {
				this.showComponent = null
			} else {
				if(this.divida.loj_codigo===171 || this.divida.loj_codigo===187) {
					this.formasPagamento = {
						boleto: [],
					}
				} else {
					this.formasPagamento = {
						boleto: [],
						cartao: [],
						pix: [],
						link: []
					}
				}

				this.SET_LOADING(true);
				this.SET_LOADING_MESSAGE("Consultando Opções de Pagamento");
				await Promise.all([
					this.action_getValoresAcordo({
						pes_codigo: this.divida.pes_codigo,
						loj_codigo: this.divida.loj_codigo,
						pre_codigo: this.divida.pre_codigos,
						site: "S",
						emp_codigo: this.divida.emp_codigo,
						pagamento_avista_prazo: "A"
					}).then(response => {
						if (!response.data) {
							this.showComponent = "PaymentOptionsDebit"
							if(this.divida.loj_codigo===171 || this.divida.loj_codigo===187) {
								this.formasPagamento.boleto = [...this.formasPagamento.boleto, ...response.boleto]
							} else {
								this.formasPagamento.boleto = [...this.formasPagamento.boleto, ...response.boleto]
								this.formasPagamento.cartao = [...this.formasPagamento.cartao, ...response.cartao]
								this.formasPagamento.pix = [...this.formasPagamento.pix, ...response.boleto]
								this.formasPagamento.link = [...this.formasPagamento.link, ...response.boleto]
							}
							
						} else {
							this.parcelaDetalhes = null
						}
					})
				])
				if (!this.divida.parcelaFases) {
					await Promise.all([
						this.action_getValoresAcordo({
							pes_codigo: this.divida.pes_codigo,
							loj_codigo: this.divida.loj_codigo,
							pre_codigo: this.divida.pre_codigos,
							site: "S",
							emp_codigo: this.divida.emp_codigo,
							pagamento_avista_prazo: "P"
						}).then(response => {
							if (!response.data) {
								this.showComponent = "PaymentOptionsDebit"
								if(this.divida.loj_codigo===171 || this.divida.loj_codigo===187) {
									this.formasPagamento.boleto = [...this.formasPagamento.boleto, ...response.boleto]
								} else {
									this.formasPagamento.boleto = [...this.formasPagamento.boleto, ...response.boleto]
									this.formasPagamento.cartao = [...this.formasPagamento.cartao, ...response.cartao]
									this.formasPagamento.pix = [...this.formasPagamento.pix, ...response.boleto]
									this.formasPagamento.link = [...this.formasPagamento.link, ...response.boleto]
								}
							} else {
								this.parcelaDetalhes = null
							}
						})
					])
				} else {
					this.divida.parcelaFases = this.divida.parcelaFases.sort((a, b) => (a.fase_desconto > b.fase_desconto ? 1 : -1))
					await Promise.all([
						this.divida.parcelaFases.forEach(fase => {
							this.action_getValoresAcordo({
								pes_codigo: this.divida.pes_codigo,
								loj_codigo: this.divida.loj_codigo,
								pre_codigo: fase.pre_codigos,
								site: "S",
								emp_codigo: this.divida.emp_codigo,
								pagamento_avista_prazo: "P",
								fases_desconto: fase.fase_desconto
							}).then(response => {
								if (!response.data) {
									this.showComponent = "PaymentOptionsDebit"
									if(this.divida.loj_codigo===171 || this.divida.loj_codigo===187) {
										this.formasPagamento.boleto = [...this.formasPagamento.boleto, ...response.boleto]
									} else {
										this.formasPagamento.boleto = [...this.formasPagamento.boleto, ...response.boleto]
										this.formasPagamento.cartao = [...this.formasPagamento.cartao, ...response.cartao]
										this.formasPagamento.pix = [...this.formasPagamento.pix, ...response.boleto]
										this.formasPagamento.link = [...this.formasPagamento.link, ...response.boleto]
									}
								} else {
									this.parcelaDetalhes = null
								}
							})
						})
					])
				}

				this.SET_LOADING(false);
				this.SET_LOADING_MESSAGE("");

				this.createParcelasFuturas()
			}
		},
		createParcelasFuturas() {
			if (this.divida.possuiLancamentosFuturos) {
				let parcelasBoleto = JSON.parse(JSON.stringify(this.formasPagamento.boleto))
				let valorTotalFuturo = this.formasPagamento.boleto[0].valor_total + this.divida.vlrDebito
				parcelasBoleto.forEach(parcela => {
					parcela.valor_total_acordo = valorTotalFuturo
					parcela.valor_total = valorTotalFuturo
					parcela.pra_valor_entrada = (parcela.valor_total_acordo / (parcela.pra_quantidade + 1)).toFixed(2)
					parcela.valor_por_parcelas = (parcela.valor_total_acordo / (parcela.pra_quantidade + 1)).toFixed(2)
					parcela.pra_valor_parcela = (parcela.valor_total_acordo / (parcela.pra_quantidade + 1)).toFixed(2)
					parcela.valor_parcela = (parcela.valor_total_acordo / (parcela.pra_quantidade + 1)).toFixed(2)
					parcela.valor_entrada = (parcela.valor_total_acordo / (parcela.pra_quantidade + 1)).toFixed(2)
					parcela.valorFuturoIncluso = true
					parcela.valorFuturoTotal = this.divida.vlrDebito
				})
				if (this.divida.flgObrigarInclusaoFuturos) {
					this.formasPagamento.boleto = [...parcelasBoleto]
				} else {
					this.formasPagamento.boleto = [...this.formasPagamento.boleto, ...parcelasBoleto]
				}
			}
		}
	}
}
</script>

<style scoped lang="scss">
.bg-page {
	box-sizing: border-box !important;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.background-card {
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	padding: 30px;
	background: var(--whiteColor);
	border-radius: 40px;
	box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	margin-top: 15px;
	margin-bottom: 5px;
	@media only screen and (max-width: 470px) {
		padding: 20px;
	}
}

.debit-card {
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	@media only screen and (max-width: 760px) {
		flex-direction: column;
		height: auto;
		max-width: 100%;
		width: auto;
	}
}

.img-box {
	width: 110px;
	height: 110px;
	display: flex;
	justify-content: center;
	align-items: center;
	object-fit: contain;
}

.img-box img {
	object-fit: contain;
	width: 110px;
}

.container-info {
	flex: 1;
	height: auto;
	margin-left: 30px;
	padding-left: 30px;
	border-left: 1px solid #f0f0f0;
	width: 100%;
	@media only screen and (max-width: 760px) {
		border: 0;
		padding: 0;
		margin: 0;
	}
}
.info {
	display: flex;
	justify-content: space-between;
	align-items: center;
	@media only screen and (max-width: 470px) {
		flex-direction: column;
		width: 100%;
		margin-top: 10px;
		text-align: center;
	}
}

.info div,
.row-info,
.row-info p,
.row-info h6 {
	@media only screen and (max-width: 470px) {
		width: 100% !important;
		text-align: center;
	}
}

.box-buttons {
	margin-top: 20px;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	@media only screen and (max-width: 470px) {
		flex-direction: column;
	}
}

.box-buttons div {
	@media only screen and (max-width: 470px) {
		width: 100% !important;
		margin: 5px 0;
		padding: 0 !important;
	}
}

.row-info {
	display: flex;
	flex-direction: column;
	margin-bottom: 10px;
	align-items: flex-start;
}
.row-info h6 {
	margin-right: 5px;
	color: #5b6987;
	font-family: "Roboto";
	font-size: 12px;
}
.row-info p {
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	width: 230px;
}

.row-totals {
	display: flex;
	flex-direction: row;
	@media only screen and (max-width: 800px) {
		flex-direction: column;
		margin-left: 20px;
	}
	@media only screen and (max-width: 470px) {
		width: 100% !important;
		margin: 10px 0 !important;
		flex-direction: row;
		justify-content: center;
		text-align: center;
	}
}
.totals {
	margin-left: 15px;
	@media only screen and (max-width: 760px) {
		margin-bottom: 20px;
	}
	@media only screen and (max-width: 470px) {
		margin: 0 !important;
	}
}

.totals h6 {
	color: #5b6987;
	color: "Roboto";
	font-size: 11px;
	margin-bottom: 3px;
}

.totals h2 {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 24px;
	@media only screen and (min-width: 761px) and (max-width: 1120px) {
		font-size: 18px;
	}
	@media only screen and (max-width: 760px) {
		font-size: 18px;
	}
}

.box-options-payment {
	margin-top: 50px;
}

.box-options-payment h2 {
	font-size: 24px;
	text-align: center;
	font-family: "Roboto Black";
	color: #031b4e;
}

.column-options-payment {
	display: flex;
	flex-direction: column;
	padding-top: 20px;
}

.paymentFormRow {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	height: 60px;
	align-items: center;
	padding: 0 20px;
	border-bottom: 1px solid var(--grayColor);
}

.paymentFormRow h4 {
	font-size: 18px;
	font-family: "Roboto Bold";
	color: #031b4e;
}

.paymentFormRow i {
	font-size: 24px;
}

.details-option {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 20px;
}

.details-option h2 {
	font-size: 24px;
	text-align: center;
	font-family: "Roboto Black";
	color: var(--blackColor);
}

.detail-row {
	padding-top: 20px;
	display: flex;
	flex-direction: row;
	width: 500px;
	justify-content: space-between;
	align-items: center;
}

.detail-row-icon {
	width: 50px;
	display: flex;
	justify-content: center;
}

.detail-row-icon i {
	font-size: 38px;
}

.detail-row-label {
	font-size: 18px;
	font-family: "Roboto Bold";
}

.detail-row-value {
	font-size: 18px;
	font-family: "Roboto Bold";
}

.container-button {
	padding-left: 20px;
	width: 100%;
}

.totals span {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 11px;
}

span.tag-porcent {
	background: var(--primaryColor);
	padding: 3px 5px;
	color: #ffffff;
	font-family: "Roboto Bold";
	font-size: 10px;
	border-radius: 27px;
}

.message-top {
	margin: 0 0 20px 0;
	font-family: "Roboto Bold";
	font-size: 14px;
	line-height: 21px;
	text-align: center;
	padding: 10px 10px;
	background: var(--primaryColor);
	color: #eeeeee;
}
.message-top b {
	font-family: "Roboto Black";
	font-size: 16px;
}

.amount-boleto {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.amount-boleto .values-boleto {
	display: flex;
	align-items: center;
	width: 300px;
	justify-content: space-between;
}

.amount-boleto .values-boleto .totals {
	padding-right: 10px;
	min-width: 130px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

@media only screen and (max-width: 768px) {
	.amount-boleto {
		flex-direction: column;
		text-align: center;
	}

	.amount-boleto div {
		margin: 10px 0;
	}

	.amount-boleto .values-boleto {
		width: 100%;
	}

	.amount-boleto .values-boleto .totals {
		align-items: flex-start;
	}
}

.amount-boleto h5 {
	font-size: 16px;
	font-family: "Roboto Bold";
	color: var(--blackColor);
}

.amount-boleto h5 b {
	font-family: "Roboto Black";
	font-size: 18px;
	color: var(--primaryColor);
}

.amount-boleto p {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 12px;
	margin-top: 3px;
}

.card-promotion-debit {
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	padding: 15px 30px;
	background: #fff;
	border-radius: 40px;
	box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
	margin-bottom: 30px;
	@media only screen and (max-width: 470px) {
		padding: 20px;
	}
}

@media only screen and (max-width: 600px) {
	.box-buttons {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.box-buttons div {
		padding: 0px;
		margin-bottom: 5px;
		width: 100%;
	}
}
</style>
